export const GuestHasCartQuery = 'has-cart'

export const GuestHasCartParam = `guest=${GuestHasCartQuery}`
